import React from 'react';

import Metadata from '@pray/shared/components/Metadata';

import { Globus, Hourglass, Microphone, Translate } from 'components/pages/public/components/icons/benefits';
import { PRODUCT_LABELS, Products } from 'components/pages/public/types/products';
import { VIEW_EVENT_NAMES } from 'constants.js';

import { Header } from '../../../../components/Header/Header';
import ProductPageLayout from '../../layout/ProductPageLayout';

const TranslationsPage: React.FC = () => {
  return (
    <div data-viewname={VIEW_EVENT_NAMES.PRODUCTS.AI_TRANSLATIONS}>
      <Metadata
        title={`Translate all of your sermons with ${PRODUCT_LABELS[Products.AI_TRANSLATIONS]} | ${
          PRODUCT_LABELS[Products.PRAYSTUDIO]
        }`}
        description={`Reach globally with ${
          PRODUCT_LABELS[Products.AI_TRANSLATIONS]
        }. Translate video and audio sermons effortlessly using ${PRODUCT_LABELS[Products.PRAYSTUDIO]}'s ${
          PRODUCT_LABELS[Products.AI_TRANSLATIONS]
        }. `}
      />
      <Header />
      <ProductPageLayout
        // Hero section
        tag={PRODUCT_LABELS[Products.AI_TRANSLATIONS]}
        icon={<Translate />}
        title="Your Voice. Many Languages."
        description="Auto-translate sermons into 30+ languages using your own voice—no agencies, no voice actors, juts one click."
        ctaText="TRY TRANSLATIONS"
        heroMedia={{
          type: 'video',
          src: 'https://d339bgihw9yfmi.cloudfront.net/web/videos/Video+Translations+with+Jeff+Schreve.mp4',
        }}
        // Benefits section
        benefitsSectionTitle="Why Translations?"
        benefits={[
          {
            icon: <Translate />,
            title: 'Speak to the Nations Seamlessly',
            description:
              'Automatically translate your sermons into multiple languages for a global audience—with new tools to increase reach.',
            linkText: 'LEARN MORE',
          },
          {
            icon: <Microphone />,
            title: 'Your Voice, Their Language',
            description:
              "Have your message delivered in your own voice, exactly as you intended it, but in their listeners' language. Keep the unique style and tone of your delivery intact.",
            linkText: 'LEARN MORE',
          },
          {
            icon: <Hourglass />,
            title: 'Save Time and Resources',
            description:
              'Share your message with the world without costly, time-consuming translation or the burden of using agencies.',
            linkText: 'LEARN MORE',
          },
          {
            icon: <Globus />,
            title: 'Open Doors to New Communities',
            description:
              'Open doors to new communities, sharing the Good News with people you’ve never been able to reach before.',
            linkText: 'LEARN MORE',
          },
        ]}
        // How it works section
        howItWorksSectionTitle="How it Works"
        steps={[
          {
            tag: 'STEP 1',
            title: 'Upload Your Sermon',
            description: `Whether it's a recent message or something from your archive, simply upload your sermon file. ${
              PRODUCT_LABELS[Products.PRAYSTUDIO]
            } accepts both audio and video formats, making it easy to get started.`,
            buttonText: 'GET STARTED',
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/translations-benefit-step-1.png',
            imageAlt: 'Upload your sermon',
          },
          {
            tag: 'STEP 2',
            title: 'Choose a Language',
            description: `Reach new communities by choosing the language you want your sermon translated into. From Spanish to Swahili,
            ${PRODUCT_LABELS[Products.PRAYSTUDIO]} supports a wide range of global languages.`,
            buttonText: 'GET STARTED',
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/translations-benefit-step-2.png',
            imageAlt: 'Choose a Language',
          },
          {
            tag: 'STEP 3',
            title: 'Get Your Voice-Translated Message',
            description: `With one click, ${
              PRODUCT_LABELS[Products.PRAYSTUDIO]
            } creates a translated version of your sermon using your own voice, keeping your tone, emotion, and message intact. No voice actors or agencies required.`,
            buttonText: 'GET STARTED',
            imageSrc: 'https://d339bgihw9yfmi.cloudfront.net/web/images/translations-benefit-step-3.png',
            imageAlt: 'Translated message',
          },
        ]}
        // Solution cards section
        solutionsSectionTitle="All-in-one Solution"
      />
    </div>
  );
};

export default TranslationsPage;
